import { Spinner } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentPage from 'src/components/ContentPage/ContentPage';

type Props = {
  text?: string;
};

export const LoadingPage: React.FC<Props> = ({ text }) => {
  const { t: tCommon } = useTranslation();

  const resolvedText = text || tCommon('loading');

  return (
    <ContentPage title={resolvedText}>
      <div className="padding-y--5 text-align--center display--flex align-items--center flex-direction--column">
        <Spinner aria-label={resolvedText} />
      </div>
    </ContentPage>
  );
};
